import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ScrollableTabsButtonAuto from './ScrollableTabsButtonAuto';
import ClientProvider from './client';
export default createDemo(import.meta.url, ScrollableTabsButtonAuto, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/tabs/demos/scrollable-button-auto/ScrollableTabsButtonAuto.tsx",
    "fileName": "ScrollableTabsButtonAuto.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Tabs from '@mui/material/Tabs';\nimport Tab from '@mui/material/Tab';\nimport Box from '@mui/material/Box';\n\nexport default function ScrollableTabsButtonAuto() {\n  const [value, setValue] = React.useState(0);\n\n  const handleChange = (event: React.SyntheticEvent, newValue: number) => {\n    setValue(newValue);\n  };\n\n  return (\n    <Box sx={{ maxWidth: { xs: 320, sm: 480 }, bgcolor: 'background.paper' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Tabs\n        value={value}\n        onChange={handleChange}\n        variant=\"scrollable\"\n        scrollButtons=\"auto\"\n        aria-label=\"scrollable auto tabs example\"\n      >\n        <Tab label=\"Item One\" />\n        <Tab label=\"Item Two\" />\n        <Tab label=\"Item Three\" />\n        <Tab label=\"Item Four\" />\n        <Tab label=\"Item Five\" />\n        <Tab label=\"Item Six\" />\n        <Tab label=\"Item Seven\" />\n      </Tabs>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 32,
        "focusedLines": 15,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Tabs from '@mui/material/Tabs';\nimport Tab from '@mui/material/Tab';\nimport Box from '@mui/material/Box';\n\nexport default function ScrollableTabsButtonAuto() {\n  const [value, setValue] = React.useState(0);\n\n  const handleChange = (event: React.SyntheticEvent, newValue: number) => {\n    setValue(newValue);\n  };\n\n  return (\n    <Box sx={{ maxWidth: { xs: 320, sm: 480 }, bgcolor: 'background.paper' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Tabs\n        value={value}\n        onChange={handleChange}\n        variant=\"scrollable\"\n        scrollButtons=\"auto\"\n        aria-label=\"scrollable auto tabs example\"\n      >\n        <Tab label=\"Item One\" />\n        <Tab label=\"Item Two\" />\n        <Tab label=\"Item Three\" />\n        <Tab label=\"Item Four\" />\n        <Tab label=\"Item Five\" />\n        <Tab label=\"Item Six\" />\n        <Tab label=\"Item Seven\" />\n      </Tabs>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Tabs"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "value"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "onChange"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleChange"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "scrollable",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "scrollButtons"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "auto",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "scrollable auto tabs example",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            "      >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Tab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Item One",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Tab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Item Two",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Tab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Item Three",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Tab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Item Four",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Tab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Item Five",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Tab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Item Six",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Tab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Item Seven",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Tabs"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 32,
    "focusedLines": 15,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Tabs",
      "@mui/material/Tab",
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
